import { types } from 'mobx-state-tree';

const NextPreviewStore = types.optional(types.map(types.frozen), {
  image: { assets: [] },
  to: '',
  title: '',
  subtitle: '',
});

export default NextPreviewStore;



// WEBPACK FOOTER //
// ./src/stores/NextPreviewStore.js